<template>
  <div>
    <NavigationBar
      titel="Einsatzmittel"
      :tabs="tabs"
      :activeTab="activeTab"
    ></NavigationBar>
    <router-view />
  </div>
</template>

<script>
import NavigationBar from "@/components/_systemwide/NavigationBar.vue";

export default {
  name: "availability-units",
  components: {
    NavigationBar,
  },
  data() {
    return {
      activeTab: `units`,
      tabs: [
        { id: 1, name: "Einsatzmittel", route: `units` },
        { id: 2, name: "Funktionen", route: `positions` },
      ],
    };
  },
};
</script>
